const data ={
    "Javascript" : 90,
    "Python" : 90,
    "NodeJS" : 80,
    "React" : 90
}
export const skillsData = data